import React, { useState, useEffect } from "react";
import { useAuth } from "@/lib/AuthContext";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Edit2, Package, Copy } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { Badge } from "@/components/ui/badge";

export default function ProductoCard({ producto, categorias, onEdit, onDuplicate, onToggleActive }) {
  const [isAdmin, setIsAdmin] = useState(false);
  const categoria = categorias.find(c => c.id === producto.categoria_id);

  /* eslint-disable-next-line no-unused-vars */
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      setIsAdmin(true);
    }
  }, [user]);

  return (
    <Card className="hover:shadow-lg transition-all duration-200 dark:bg-gray-900 dark:border-gray-800">
      <CardHeader className="pb-3">
        <div className="flex items-start justify-between">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 bg-indigo-100 dark:bg-indigo-950 rounded-lg flex items-center justify-center">
              <Package className="w-5 h-5 text-indigo-600 dark:text-indigo-400" />
            </div>
            <div>
              <CardTitle className="text-lg text-gray-900 dark:text-white">{producto.nombre}</CardTitle>
              {categoria && (
                <Badge variant="outline" className="mt-2 dark:border-gray-700">
                  {categoria.nombre}
                </Badge>
              )}
            </div>
          </div>
          <div className="flex gap-1">
            <Button variant="ghost" size="sm" onClick={() => onDuplicate(producto)} title="Duplicar producto">
              <Copy className="w-4 h-4" />
            </Button>
            <Button variant="ghost" size="sm" onClick={() => onEdit(producto)} title="Editar producto">
              <Edit2 className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </CardHeader>
      
      <CardContent className="space-y-3">
        {producto.descripcion && (
          <p className="text-sm text-gray-600 dark:text-gray-400">{producto.descripcion}</p>
        )}

        {isAdmin && (producto.margen_propio !== null && producto.margen_propio !== undefined) && (
          <div className="flex justify-between items-center">
            <span className="text-sm text-gray-600 dark:text-gray-400">Margen propio</span>
            <Badge className="bg-indigo-100 dark:bg-indigo-950 text-indigo-700 dark:text-indigo-300">
              {producto.margen_propio}%
            </Badge>
          </div>
        )}

        {isAdmin && (producto.coste_fijo_propio !== null && producto.coste_fijo_propio !== undefined) && (
          <div className="flex justify-between items-center">
            <span className="text-sm text-gray-600 dark:text-gray-400">Coste fijo propio</span>
            <Badge className="bg-green-100 dark:bg-green-950 text-green-700 dark:text-green-300">
              {producto.coste_fijo_propio}€
            </Badge>
          </div>
        )}

        <div className={`flex justify-between items-center ${isAdmin && (producto.margen_propio || producto.coste_fijo_propio) ? 'pt-3 border-t border-gray-200 dark:border-gray-700' : ''}`}>
          <span className="text-sm text-gray-600 dark:text-gray-400">Activo</span>
          <Switch
            checked={producto.activo}
            onCheckedChange={(checked) => onToggleActive(producto.id, checked)}
          />
        </div>
      </CardContent>
    </Card>
  );
}